import React from 'react';

import Tick from './tick.svg';

export default props => <img {...props} src={Tick} alt="" />;
